/**
 * Date Helper Functions
 * Utilities for date calculations in schedules
 */

import dayjs from 'dayjs';

/**
 * Get formatted date range string for a week
 * @param {dayjs.Dayjs} selectedWeek - The base week
 * @param {number} weekOffset - Offset in weeks from base
 * @returns {string} Formatted date range "DD/MM/YYYY - DD/MM/YYYY"
 */
export const getWeekDateRange = (selectedWeek, weekOffset) => {
  const monday = dayjs(selectedWeek).add(weekOffset * 7, 'day');
  const sunday = monday.add(6, 'day');
  
  const formatDate = (date) => date.format('DD/MM/YYYY');
  
  return `${formatDate(monday)} - ${formatDate(sunday)}`;
};

/**
 * Get the date for a specific day in the week
 * @param {dayjs.Dayjs} selectedWeek - The base week (Monday)
 * @param {number} dayValue - Day value (0 = Sunday, 1 = Monday, etc.)
 * @returns {dayjs.Dayjs} The date for that day
 */
export const getDateForDay = (selectedWeek, dayValue) => {
  // Convert day value to day offset from Monday
  const dayOffset = dayValue === 0 ? 6 : dayValue - 1;
  return selectedWeek.add(dayOffset, 'day');
};

/**
 * Format week display string (short format)
 * @param {dayjs.Dayjs} weekStart - Start of week
 * @returns {string} "DD/MM - DD/MM/YYYY"
 */
export const formatWeekDisplay = (weekStart) => {
  return `${weekStart.format('DD/MM')} - ${weekStart.add(6, 'day').format('DD/MM/YYYY')}`;
};

/**
 * Format week display string (compact format)
 * @param {dayjs.Dayjs} weekStart - Start of week
 * @returns {string} "DD/MM - DD/MM"
 */
export const formatWeekDisplayCompact = (weekStart) => {
  return `${weekStart.format('DD/MM')} - ${weekStart.add(6, 'day').format('DD/MM')}`;
};

